import { render, staticRenderFns } from "./PainelProjetosComprasAGETIC.vue?vue&type=template&id=75678144"
import script from "./PainelProjetosComprasAGETIC.vue?vue&type=script&lang=js"
export * from "./PainelProjetosComprasAGETIC.vue?vue&type=script&lang=js"
import style0 from "./PainelProjetosComprasAGETIC.vue?vue&type=style&index=0&id=75678144&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports